import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link, NavLink, useOutletContext, useParams } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import { MaterialReactTable } from "material-react-table";
import { decodeHtml } from "../../../utils/decodeHtml";
import { colors } from "@mui/material";
import ChangeLogTrend from "../components/ChangeLogWeekly";


function UnitChangeLog() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [data, setData] = useState([]);
  const [changeLogOptions, setChangeLogOptions] = useState([]);
  const [optionsWeekly, setOptionsWeekly] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();
  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  async function fetchOptions() {
    setGlobalLoading(true);
    try {
        const response = await axios.get(
        `${API_BASE_URL}/reports/get_unit_changelog/`,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
        );
        setChangeLogOptions(response.data.changelog_data || []);
        setOptionsWeekly(response.data.changelog_weekly_data || []);
  
        const d = response.data;
        if (response.status === 200) {
            setData({
            ...d,
            });
        }
    } catch (error) {
        console.error("API Error:", error);
        // setoptions([]);
    } finally {
        setGlobalLoading(false); 
    }
  }

  useEffect(() => {
    if (token) {
        fetchOptions();
    }
  }, [token]); 

  const financialYears = Array.from({ length: 4 }, (_, i) => {
  const start = new Date().getFullYear() - i;
  const end = start + 1;
    return {
      label: `${start}-${end}`,
      value: `${start}-${end}`,
    };
  });  

    const thisWeekData = changeLogOptions.filter(
    (item) => item.week_category === "This Week"
    );

    const prevWeekData = changeLogOptions.filter(
    (item) => item.week_category === "Previous Week"
    );

    const renderTable = (data) => (
    <div className="table-responsive">
        <table className="table text-nowrap table-bordered">
            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1}}>
                <tr>
                <th className="sticky-col-1">Role Manager</th>
                <th>Assign</th>
                <th>Client</th>
                <th>Role</th>
                <th>Retainer</th>
                <th>Amt</th>
                <th>Date</th>
                <th>Sector</th>
                <th>Status</th>
                <th>Comments</th>
                </tr>
            </thead>

            <tbody>
                {data.map((row, index) => (
                <tr>
                    <td className="sticky-col-1">{row.role_manager}</td>
                    <td>{row.assign_to}</td>
                    <td>{row.client}</td>
                    <td>
                    {row.role}
                    {row.financial_year && (
                        <span
                        style={{
                            color: "red",
                            marginLeft: "5px",
                            fontSize: "11px",
                        }}
                        >
                        ({row.financial_year})
                        </span>
                    )}
                    </td>
                    <td>{row.retainer}</td>
                    <td
                    style={{ textAlign: "right" }}
                    className={
                        Number(row.amount) < 0 ? "text-danger" : "text-success"
                    }
                    >
                    {formatNumber(Number(row.amount).toFixed(0))}
                    </td>
                    <td>{row.change_date}</td>
                    <td>{row.sector}</td>
                    <td>{row.status}</td>
                    <td>{row.comments}</td>
                </tr>
                ))}
            </tbody>
        </table>
    </div>
    );

    const getTotal = (arr) =>
    arr.reduce((sum, item) => sum + Number(item.amount || 0), 0);

    const thisWeekTotal = getTotal(thisWeekData);
    const prevWeekTotal = getTotal(prevWeekData);

    const growth =
    prevWeekTotal !== 0
        ? (
            ((thisWeekTotal - prevWeekTotal) /
            Math.abs(prevWeekTotal)) *
            100
        ).toFixed(2)
        : 0;

    return (
        <>
        <style>
        {`
        .table {
            font-size: 12px;
            margin-bottom: 0;
          }
          .table th,
          .table td {
            padding: 4px 8px !important;
            white-space: nowrap;
            vertical-align: middle;
            line-height: 1.2;
          }
          .table-responsive {
            overflow: auto;
            max-height: 500px;
          }
          /* Header */
          thead th {
            position: sticky;
            top: 0;
            background: #f5f5f5 !important;
            z-index: 20;
            font-weight: 600;
          }
          /* 1st column - Unit Head */
          .sticky-col-1 {
            position: sticky;
            left: 0;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 2nd column - Generated / Net Add */
          .sticky-col-2 {
            position: sticky;
            left: 100px;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 3rd column - Revenue Total */
          .sticky-col-3 {
            position: sticky;
            left: 200px;
            background: #fff;
            z-index: 15;
            min-width: 140px;
          }
          /* Sticky header + sticky columns */
          thead .sticky-col-1,
          thead .sticky-col-2,
          thead .sticky-col-3 {
            background: #f5f5f5 !important;
            z-index: 25;
          }
          /* Optional border */
          .sticky-col-1,
          .sticky-col-2,
          .sticky-col-3 {
            box-shadow: 1px 0 0 #ddd;
          }
        .chart-box {
              min-height: 250px; /* adjust as needed */
              display: flex;
              flex-direction: column;
          }    
        `}
        </style>  
  
        {/* THIS WEEK */}
        <div className="card shadow-sm mb-4">
        <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
            <h5 className="mb-0">This Week</h5>
            <h5 className="mb-0 text-success">
                ₹ {formatNumber(thisWeekTotal.toFixed(0))}
            </h5>
            </div>

            {renderTable(thisWeekData)}
        </div>
        </div>

        {/* PREVIOUS WEEK */}
        <div className="card shadow-sm mb-4">
        <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
            <h5 className="mb-0">Previous Week</h5>
            <h5 className="mb-0 text-primary">
                ₹ {formatNumber(prevWeekTotal.toFixed(0))}
            </h5>
            </div>

            {renderTable(prevWeekData)}
        </div>
        </div>

        {/* GROWTH SUMMARY */}
        <div className="card shadow-sm mb-4">
        <div className="card-body text-center">
            <h5>Weekly Growth</h5>

            <h3
            className={
                Number(growth) >= 0
                ? "text-success"
                : "text-danger"
            }
            >
            {growth}% {Number(growth) >= 0 ? "▲" : "▼"}
            </h3>

            <div className="row mt-3">
            <div className="col-md-6">
                <strong>This Week</strong>
                <br />
                ₹ {formatNumber(thisWeekTotal.toFixed(0))}
            </div>

            <div className="col-md-6">
                <strong>Previous Week</strong>
                <br />
                ₹ {formatNumber(prevWeekTotal.toFixed(0))}
            </div>
            </div>
        </div>
        </div>
        <div className="card shadow-sm mb-4">
        <div className="card-body">
            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                    Net-Add Weekly Trend
                </h5>
            </div>
            <ChangeLogTrend chart_data={optionsWeekly} />
        </div>
        </div>

        </>
    );
}

export default UnitChangeLog;